import { InjectionToken } from '@angular/core';

export const LANGUAGE_CODE = new InjectionToken<string>('LanguageCode');

export interface TranslationsMap {
    de: { [key: string]: string };
    en: { [key: string]: string };
    fr: { [key: string]: string };
    ja: { [key: string]: string };
}
